function TouristSpotPhotosUserImage({ url }) {
  return <> {url ? <img src={url} alt="" width="100%" /> : "N/A"}</>;
}

export default TouristSpotPhotosUserImage;
